class CopyText {
  constructor(copyButtonID, textToCopy) {
    this.copyButtonID = copyButtonID;
    this.textToCopy = textToCopy;
    this.copyButtonElement = document.getElementById(this.copyButtonID);
    this.copyButtonInnerText = this.copyButtonElement.innerHTML;
  }

  copy() {
    this.copyButtonElement.addEventListener('click', () => {
      this.copyButtonElement.innerHTML = "Copied"
      navigator.clipboard.writeText(this.textToCopy);

      setTimeout(() => {
        this.copyButtonElement.innerHTML = this.copyButtonInnerText;
      }, 2500);
    })
  }
}


window.addEventListener('load', () => {
  if (document.getElementById('copybutton__text')) {
    let copyText = new CopyText('copybutton__text', `${window.location.href}?utm_medium=website&utm_source=blog&utm_campaign=share-copy`);
    copyText.copy();
  }
})
